import React from "react";
import { Routes, Route, useLocation, matchPath } from "react-router-dom";
import "./App.css";

import Footer from "./components/Footer";
import Header from "./components/Header";
import { Toaster } from "react-hot-toast";

// Public Pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Solution from "./pages/Solution";
import Event from "./pages/Event";
import Jobs from "./pages/Jobs";
import Jobdetail from "./components/Jobdetail";
import EventDescription from "./components/EventDescription";
import BusinessIdeationHub from "./pages/BusinessIdeationHub";
import Businessconsultation from "./pages/BusinessConsultation";
import StartUps from "./components/StartUps";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndCondition from "./components/TermsAndCondition";
import MatrimonyProtectedRoutes from "./components/MatrimonyProtectedRoutes";

// Startup Dashboard
import Funding from "./startupdashboard/Funding";
import Login from "./startupdashboard/Login";
import Loginnew from "./startupdashboard/Loginnew";
import MainDashboard from "./startupdashboard/MainDashboard";
import AdminProfile from "./startupdashboard/Adminprofile";
import StartupProfile from "./startupdashboard/StartupProfile";
import AdminJobPortal from "./startupdashboard/AdminJobPortal";
import AdminCaPortal from "./startupdashboard/AdminCaPortal";

// Startup Registration
import StartupRegistration from "./pages/StartupRegistration";
import RegistrationforCofounder from "./pages/RegistrationforCofounder";

// Matrimony Pages
import Matrimony from "./pages/Matrimony";
import MatrimonyReg from "./pages/MatrimonyReg";
import MatrimonyPreference from "./pages/MatrimonyPreference";
import MatrimonyLogin from "./pages/MatrimonyLogin";
import MatrimonyPricing from "./pages/MatrimonyPricing";
import MatrimonyProfile from "./pages/MatrimonyProfile";
import MatrimonyProfileDetail from "./pages/MatrimonyProfileDetail";
import MatrimonyEditMyProfile from "./pages/MatrimonyEditMyProfile";
import ProfileListing from "./pages/ProfileListing";
import EntrepreneurProfilesPage from "./pages/EntrepreneurProfilesPage";
import RecentUploadsPage from "./pages/RecentUploadsPage";
import ChatList from "./pages/ChatList";
import Request from "./pages/Request";
import Setting from "./pages/Setting";
import Privacy from "./components/Privacy";
import TermsAndConditions from "./components/TermsAndConditions";
import StartupProtectedRoutes from "./components/StartupProtectedRoutes";
import JobPortal from "./startupdashboard/JobPortal";
import AdminSetting from "./startupdashboard/AdminSetting";
import MatrimonyDashboard from "./pages/MatrimonyDashboard";
import CaLogin from "./ca-portal/CaLogin";
import CaDashboard from "./ca-portal/CaDashboard";
import CaMainDashboard from "./ca-portal/CaMainDashboard";
import TicketInterface from "./ca-portal/TicketInterface";
import TicketConversation from "./ca-portal/ca-ticket-conversation";
import RefundPolicy from "./components/RefundPolicy";
import CrmPricing from "./pages/CrmPricing";
import CrmOnboarding from "./pages/CrmOnboarding";
import ChatPage from "./startupdashboard/ChatPage"
import ScrollRestoration from "./components/ScrollRestoration";
import PaymentGateways from "./startupdashboard/PaymentGateway";
import Report from "./startupdashboard/Reports";
import ForgotPassword from "./startupdashboard/ForgotPassword";
import ResetPassword from "./startupdashboard/ResetPassword";
import PaymentCallback from "./pages/PaymentCallback";
import AdminMentor from "./startupdashboard/AdminMentor";
import ProtectedBlurRoute from "./components/ProtectedBlurRoute";
import StartupWorkspaces from "./startupdashboard/StartupWorkspaces";

import CoWorkingSpaces from "./pages/CoWorkingSpaces";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import InvestmenPage from "./components/TactosInstructionComponents/InvestmenPage";
import StudentAmbassoderPage from "./components/TactosInstructionComponents/StudentAmbassoderPage";
import StartupIdeaPage from "./components/TactosInstructionComponents/StartupIdeaPage";
import ResidencyPage from "./components/TactosInstructionComponents/ResidencyPage";
import BussinessPage from "./components/TactosInstructionComponents/BussinessPage";
import InvestorsTactos from "./pages/InvestorsTactos";
import AdminForum from "./startupdashboard/AdminForum";
import ForumMain from "./pages/ForumMain";
import MentorLogin from "./pages/MentorLogin";
import MentorRegister from "./pages/MentorRegister";
import MentorDashboard from "./pages/MentorDashboard";
import MentorRequests from "./pages/MentorRequets";
import MeetingApplicants from "./pages/MeetingApplicants";
import MentorMainDashboard from "./pages/MentorMainDashboard";
import MeetingsDashboard from "./pages/MeetingsDashboard";
import MentorCalendorDashboard from "./pages/MentorCalendorDashboard";
import ForumDetails from "./pages/ForumDetails";
import MentorPayoutRequests from "./pages/MentorPayoutRequests";
import StartupMeetings from "./startupdashboard/StartupMeetings";


function App() {
  const location = useLocation();
  const path = location.pathname;




  const isStartupDashboardRoute = path.startsWith("/startup-dashboard");

  const omitLayoutPaths = [
    '/startupmeetings',
    "/mentorpayout",
    "/mentorcalendor",
    "/startup-reg",
    "/cofounder-reg",
    '/mentorlogin',
    '/mentormeetingsdashboard',
    '/mentormaindashboard',
    '/meetingapplicants/:id',
    '/mentorrequests',
    '/mentorregister',
    '/mentordashboard',
    "/login",
    "/startup-dashboard",
    "/startup-workspace",
    "/payment-callback/:type/:orderId",
    "/mentor",
    "/profile",
    "/funding",
    "/forum",
    
    "/job-portal",
    "/ca-portal",
    "/matrimony-register",
    "/matrimony-login",
    "/matrimony",
    "/matrimony-profile",
    "/matrimony-pricing",
    "/matrimony-editmyprofile",
    "/matrimony-preference",
    "/subscription",
    "/chatlist",
    "/request",
    "/setting",
    "/profile-listing",
    "/matrimony/profile-details/:id",
    "/matrimony/profiles/entrepreneur",
    "/matrimony/profiles/recent",
    "/admin-setting",
    "/dashboard",
    "/crm",
    "/ca-login",
    "/ca-dashboard",
    "/ticket-interface",
    '/ticket-conversation',
    "/tickets/:ticketId",
    "/admin-ca/chat/:ticketId",
    "/payment-gateways",
    "/reports",
    "/forgot-password",
    "/reset-password/:token",
  ];

  const isOmitLayout = omitLayoutPaths.some((pattern) =>
    matchPath({ path: pattern, end: true }, path)
  );

  const showHeader = !isStartupDashboardRoute && !isOmitLayout;
  const showFooter = ["/", "/term", "/privacy",].includes(path);

  const isLoggedIn = !!localStorage.getItem("token");


  return (
    <div className="App">
      <Toaster position="top-right" />
      {showHeader && <Header />}


      <ScrollRestoration />
      <Routes>
        {/* 🌐 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/forumsmain" element={<ForumMain />} />
         <Route path="/forumsmain/:id" element={<ForumDetails />} />
        <Route path="/solutions" element={<Solution />} />
        <Route path="/view-details/:id" element={< ViewDetailsPage />} />
        <Route path="/coworkingspaces" element={<CoWorkingSpaces />} />
        
        <Route path="/events" element={<Event />} />
        <Route path="/event-description/:id" element={<EventDescription />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jd/:id" element={<Jobdetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/startups" element={<ProtectedBlurRoute element={StartUps} isLoggedIn={isLoggedIn} />} />
        <Route path="/business-idea-hub" element={<BusinessIdeationHub />} />
        <Route path="/business-consultation" element={<Businessconsultation />} />
        <Route path="/startup-reg" element={<StartupRegistration />} />
        <Route path="/cofounder-reg" element={<RegistrationforCofounder />} />
        <Route path="/login" element={<Loginnew />} />
        <Route path="/mentorlogin" element={<MentorLogin />} />
        <Route path="/mentorregister" element={<MentorRegister />} />
        <Route path="/terms" element={<TermsAndCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/payment-callback/:type/:orderId" element={<PaymentCallback />} />
        <Route path="/instructions/investment" element={<InvestmenPage />} />
        <Route path="/instructions/studentambassoder" element={<StudentAmbassoderPage />} />
        <Route path="/instructions/startuppage" element={<StartupIdeaPage />} />
        <Route path="/instructions/residencypage" element={<ResidencyPage />} />
        <Route path="/instructions/bussiness" element={<BussinessPage />} />

        {/* 🚀 Startup Dashboard Routes */}
        <Route element={<StartupProtectedRoutes />}>
        <Route path="/investors" element={<InvestorsTactos />} />
          <Route path="/startup-dashboard" element={<MainDashboard />} />
          <Route path="/mentor" element={<AdminMentor />} />
          {/* <Route path="/startup-workspace" element={<StartupWorkspaces />} /> */}

          <Route path="/profile" element={<AdminProfile />} />
          <Route path="/job-portal" element={<JobPortal />} />
          <Route path="/funding" element={<Funding />} />
          <Route path="/forum" element={<AdminForum />} />
          <Route path="/startupmeetings" element={<StartupMeetings />} />
          
          <Route path="/ca-portal" element={<AdminCaPortal />} />
          <Route path="/payment-gateways" element={<PaymentGateways />} />
          <Route path="/reports" element={<Report />} />
          <Route path="/admin-setting" element={<AdminSetting />} />
          <Route path="/crm" element={<CrmPricing />} />
        </Route>

        <Route path="/crm-onboarding" element={<CrmOnboarding />} />

        {/* 💍 Matrimony Public Routes */}
        <Route path="/matrimony-login" element={<MatrimonyLogin />} />
        <Route path="/matrimony-register" element={<MatrimonyReg />} />
        <Route path="/matrimony-preference" element={<MatrimonyPreference />} />
        <Route path="/matrimony-profile" element={<MatrimonyProfile />} />
        <Route
          path="/matrimony/profiles/entrepreneur"
          element={<EntrepreneurProfilesPage />}
        />
        <Route
          path="/matrimony/profiles/recent"
          element={<RecentUploadsPage />}
        />
        <Route path="/matrimony-pricing" element={<MatrimonyPricing />} />
        <Route
          path="/matrimony/profile-details/:id"
          element={<MatrimonyProfileDetail />}
        />
        <Route
          path="/matrimony-editmyprofile"
          element={<MatrimonyEditMyProfile />}
        />
        <Route path="/profile-listing" element={<ProfileListing />} />
        <Route path="/chatlist" element={<ChatList />} />
        <Route path="/request" element={<Request />} />
        <Route path="/setting" element={<Setting />} />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/term" element={<TermsAndConditions />} />
        <Route path="/chatlist" element={<ChatList />} />

        {/* ✅ Matrimony Protected Routes */}
        <Route element={<MatrimonyProtectedRoutes />}>
          <Route path="/matrimony" element={<Matrimony />} />
          <Route path="/matrimony-profile" element={<MatrimonyProfile />} />
          <Route path="/matrimony-pricing" element={<MatrimonyPricing />} />
          <Route path="/profile-listing" element={<ProfileListing />} />
          <Route path="/matrimony/profile-details/:id" element={<MatrimonyProfileDetail />} />
          <Route path="/matrimony/profiles/entrepreneur" element={<EntrepreneurProfilesPage />} />
          <Route path="/matrimony/profiles/recent" element={<RecentUploadsPage />} />
          <Route path="/matrimony-editmyprofile" element={<MatrimonyEditMyProfile />} />
          <Route path="/request" element={<Request />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/dashboard" element={<MatrimonyDashboard />} />
        </Route>

        {/* ✅ CA Routes */}
        <Route path="/ca-login" element={<CaLogin />} />
        <Route path="/ca-dashboard" element={<CaMainDashboard />} />
        <Route path="/ticket-interface" element={<TicketInterface />} />
        <Route path="/tickets/:ticketId" element={<TicketConversation />} />
        <Route path="/admin-ca/chat/:ticketId" element={<ChatPage />} />

        
   <Route path="/mentormaindashboard" element={<MentorMainDashboard />} />
   <Route path="/mentorcalendor" element={<MentorCalendorDashboard />} />
   {/* <Route path="/mentormeetingsdashboard" element={<MeetingsDashboard />} /> */}
   <Route path="/mentordashboard" element={<MentorDashboard />} />
   <Route path="/mentorrequests" element={<MentorRequests />} />
   <Route path="/meetingapplicants/:id" element={<MeetingApplicants />} />
   <Route path="/mentorpayout" element={<MentorPayoutRequests />} />

      </Routes>

      {showFooter && <Footer />}
    </div>
  );
}

export default App;